import React, { useEffect, useState } from "react";
import { Modal } from "semantic-ui-react";
import { ProductForm } from "./ProductFormPage";
import { ReviewSelectionPage } from "./ReviewSelectionPage";
import { AddSupplyUnitPage } from "./AddSupplyUnitPage";

export const CreateProductWizard = ({
  onClose,
  preselectedSupplyUnits = [],
  initialProduct,
  initialPage = 1,
  mode, // create, duplicate, or edit
}) => {
  const [page, setPage] = useState(initialPage);
  const [product, setProduct] = useState({
    title: "",
    asin: "",
    partNumber: "",
    families: [],
  });

  const [supplyUnits, setSupplyUnits] = useState(preselectedSupplyUnits);

  useEffect(() => {
    if (initialProduct) {
      setProduct({
        product_id: mode === "edit" ? initialProduct.product_id : undefined,
        title: initialProduct.title,
        asin: mode === "edit" ? initialProduct.asin : "",
        partNumber: initialProduct.partNumber,
        families: initialProduct.families,
      });
    }
  }, [initialProduct, mode]);

  const nextPage = () => setPage((curr) => (curr += 1));
  const prevPage = () => setPage((curr) => (curr -= 1));

  const getModalHeader = () => {
    switch (mode) {
      case "edit":
        return "Edit Listing";
      case "duplicate":
        return "Duplicate Existing Listing";
      case "create":
      default:
        return "Create New Listing";
    }
  };

  const renderPageContent = () => {
    switch (page) {
      case 1:
        return (
          <ProductForm
            preselectedSupplyUnits={preselectedSupplyUnits}
            product={product}
            setProduct={setProduct}
            nextPage={nextPage}
            onClose={onClose}
          />
        );
      case 2:
        return (
          <AddSupplyUnitPage
            mode={mode}
            initialProduct={initialProduct}
            preselectedSupplyUnits={preselectedSupplyUnits}
            product={product}
            setProduct={setProduct}
            nextPage={nextPage}
            prevPage={prevPage}
            setSupplyUnits={setSupplyUnits}
            supplyUnits={supplyUnits}
          />
        );
      case 3:
        return (
          <ReviewSelectionPage
            prevPage={prevPage}
            product={product}
            initialProduct={initialProduct}
            setProduct={setProduct}
            supplyUnits={supplyUnits}
            onClose={onClose}
            mode={mode}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Modal open onClose={onClose} closeOnDimmerClick={true} size="large">
      <Modal.Header>{getModalHeader()}</Modal.Header>
      {renderPageContent()}
    </Modal>
  );
};
